export const LANG_TITLE = 'HỆ THỐNG MINI PACS - BỆNH VIỆN ĐA KHOA GIA ĐÌNH ĐÀ NẴNG';
